/**
 * Decides whether the dev mock stands in for the Server surface.
 *
 * Rules:
 *   ?mock=0  never mock, even if the Server is down (see the real error states)
 *   ?mock=1  always mock
 *   default  probe the Server once; mock only if it does not answer JSON
 *
 * Production builds never reach any of this — installMock() is a no-op outside
 * import.meta.env.DEV.
 */
import { API_BASE } from '../api'
import { bridge } from '../bridge'
import { installMock } from './transport'

export { completeMockGoogleSignIn, isMockInstalled, markMockAuthenticated } from './transport'

export async function installMockIfServerIsDown(): Promise<void> {
  if (!import.meta.env.DEV) return
  const flag = new URLSearchParams(location.search).get('mock')
  if (flag === '0') return
  if (flag === '1') {
    installMock()
    return
  }

  try {
    const response = await fetch(`${API_BASE}/settings`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    })
    // Any JSON answer means the Server is up — 401 included.
    if ((response.headers.get('content-type') ?? '').includes('json')) {
      bridge.log('api: Server surface answered on /api/v1 — using real data')
      return
    }
  } catch {
    /* fall through to the mock */
  }
  installMock()
}
